import { Locale } from '../../../../localization/LocalizationKeys';
import { personSelectionRowFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { PersonSelectionRowCriteriaOrder } from '../../../../gql/typings';

export const personSelectionRowSelectionTypeFieldConfig = personSelectionRowFieldConfig(
  'selectionType',
  [
    'selectionRow.id',
    'selectionRow.group.id',
    'selectionRow.group.selection.id',
    'selectionRow.group.selection.type',
  ],
  ({ localization }) => ({
    title: localization.formatMessage(Locale.Attribute.Selection_type),
    sorting: {
      ascend: PersonSelectionRowCriteriaOrder.SELECTION_TYPE_ASC,
      descend: PersonSelectionRowCriteriaOrder.SELECTION_TYPE_DESC,
    },
    render: record => record.selectionRow?.group.selection.type ?? localization.formatMessage(Locale.General.Unknown),
  }),
);
